export default __webpack_public_path__ + "static/media/Personal Details image.c7f80428.svg";